export interface Testimonial {
  id: number;
  quote: string;
  author: string;
  organization?: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    quote: "The SDW faculty, from booking the workshop to the instructors, were beyond organized, professional, and incredibly talented. We all had an awesome time!",
    author: "Samantha McShane",
  },
  {
    id: 2,
    quote: "Stage Door was so organized and nice to our large group! The experience was great!",
    author: "Samantha Peterson",
  },
  {
    id: 3,
    quote: "Great talent and technical! Add in high energy with motivation. Hard work and inspiration! My daughter loved it! 6 stars with an extra bonus one.\u2B50\u2B50\u2B50\u2B50\u2B50BONUS\u2B50",
    author: "Jamie Thorp Watts",
  },
  {
    id: 4,
    quote: "Stage Door Workshops people are fantastic. They really listened to us and gave us what we needed.",
    author: "Madonna Rothwell",
    organization: "Madonna's SOD",
  },
  {
    id: 5,
    quote: "Our studio absolutely loved Kenny. They were starstruck! I can't thank SDW enough for helping us elevate our studio's game! We are so appreciative for providing our students with excellent teachers.",
    author: "Caley",
    organization: "Barbara's School of the Dance",
  },
  {
    id: 6,
    quote: "SDW, from booking the workshop to the instructors, was beyond organized, professional, and incredibly talented.",
    author: "Samantha",
    organization: "Shooting Stars Performing Arts",
  },
  {
    id: 7,
    quote: "I can't thank you enough for the opportunity to host a BTMC. He taught a Newsies class with enthusiasm & instruction. He took the time to help each student overcome their fears of performing.",
    author: "Mara Merritt",
    organization: "Merritt Dance Center",
  },
  {
    id: 8,
    quote: "It was a pleasure to have SDW at our school. We were very inspired with every class, and we are looking forward to have you again. It was truly an amazing learning experience for our students.",
    author: "Valerie Barreriro",
    organization: "Miami Arts Charter",
  },
  {
    id: 9,
    quote: "SDW is about education & not about making the day into a competition amidst the team! Each student was recognized for their efforts & every correction was motivating, not deteriorating.",
    author: "Vanessa Berry",
    organization: "Kick Fitness and Dance",
  },
];
